import type { LifeCycleProduct } from 'apiConnector/discover/lifeCycle';
import { MouseEventHandler, ReactNode, useCallback } from 'react';
import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';

const WordBreakAllDiv = styled.div`
  word-break: break-all;
`;

interface Props {
  children: ReactNode;
  lifecyclePortalUrl: string;
  product: LifeCycleProduct;
  trackOpenProductDetail: () => void;
  openInSecondary: (isin: string) => void;
}

export function ProductListEntry({
  lifecyclePortalUrl,
  product,
  trackOpenProductDetail,
  children,
  openInSecondary,
}: Props) {
  const onNavigateToPortfolioClicked = useCallback(() => {
    window.open(`${lifecyclePortalUrl}/portfolio/product-key/${product.productKey}?tab=details`, '_blank');
    trackOpenProductDetail();
  }, [trackOpenProductDetail, lifecyclePortalUrl, product.productKey]);
  const onNavigateToSecondaryClicked: MouseEventHandler<HTMLAnchorElement> = useCallback(
    e => {
      e.stopPropagation();
      openInSecondary(product.isin);
    },
    [openInSecondary, product.isin],
  );
  return (
    <button
      className="list-group-item list-group-item-action col d-flex align-items-center px-1 py-2"
      data-e2e="life-cycle-product"
      onClick={onNavigateToPortfolioClicked}
    >
      <div className="flex-grow-1">
        <div className="container border-start">
          <WordBreakAllDiv className="fw-semibold" data-e2e="life-cycle-product-name">
            {product.productName}
          </WordBreakAllDiv>
          <div className="text-secondary" data-e2e="life-cycle-product-isin">
            <a className="text-secondary " data-e2e="life-cycle-product-isin" onClick={onNavigateToSecondaryClicked}>
              {product.isin}
            </a>
          </div>
        </div>
      </div>
      <div className="flex-grow-0">{children}</div>
    </button>
  );
}

export function ProductListEntrySkeleton() {
  return (
    <span className="list-group-item list-group-item-action col d-flex align-items-center px-1 py-2">
      <div className="col-8">
        <div className="container border-start">
          <div className="fw-semibold">
            <Skeleton />
          </div>
          <div className="text-secondary">
            <Skeleton width="12rem" />
          </div>
        </div>
      </div>
      <div className="col-4 text-end">
        <Skeleton width="3rem" />
      </div>
    </span>
  );
}
